import dayjs from 'dayjs';

import { FaberPolicyStatus } from './enums';

export const tuitionRedStatuses: string[] = [
  FaberPolicyStatus.Inactive,
  FaberPolicyStatus.Expired,
  FaberPolicyStatus.PaymentFailed,
  FaberPolicyStatus.PermSuspended,
  FaberPolicyStatus.Cancelled,
  FaberPolicyStatus.StuckPolicy,
];
export const isTuitionRedStatus = (status: FaberPolicyStatus) => tuitionRedStatuses.includes(status);

export const isTuitionGreenStatus = (status: FaberPolicyStatus, startDate: string) => FaberPolicyStatus.Active === status && dayjs().isAfter(dayjs(startDate));
export const isTuitionBlueStatus = (status: FaberPolicyStatus, startDate: string) => FaberPolicyStatus.Preactive === status
  || (FaberPolicyStatus.Active === status && dayjs(startDate).isAfter(dayjs()));
export const isActiveorPreActive = (status: FaberPolicyStatus, startDate: string) => isTuitionGreenStatus(status, startDate) || isTuitionBlueStatus(status, startDate);

export const tuitionMonochromeStatuses: string[] = [
  FaberPolicyStatus.Pending,
];
export const isTuitionMonochromeStatus = (status: FaberPolicyStatus) => tuitionMonochromeStatuses.includes(status);

export const getStatusColor = (status: FaberPolicyStatus, startDate: string, onError?: (status: string, startDate: string) => void) => {
  if (isTuitionBlueStatus(status, startDate)) return 'primary';
  if (isTuitionGreenStatus(status, startDate)) return 'success';
  if (isTuitionMonochromeStatus(status)) return 'neutral';
  if (isTuitionRedStatus(status)) return 'error';
  onError?.(status, startDate);
  return 'neutral';
};

export const getStatusLabel = (status: FaberPolicyStatus, startDate: string, onError?: (status: string, startDate: string) => void) => {
  switch (status) {
    case FaberPolicyStatus.Active: {
      const isFuture = dayjs(startDate).isAfter(dayjs());
      return isFuture ? 'upcoming' : 'active';
    }
    case FaberPolicyStatus.Preactive: return 'upcoming';
    case FaberPolicyStatus.Cancelled: return 'cancelled';
    case FaberPolicyStatus.Inactive: return 'inactive';
    case FaberPolicyStatus.Expired: return 'expired';
    case FaberPolicyStatus.PermSuspended: return 'perm suspended';
    case FaberPolicyStatus.StuckPolicy: return 'stuck policy';
    case FaberPolicyStatus.PaymentFailed: return 'payment failed';
    case FaberPolicyStatus.Pending: return 'pending';
    default: {
      onError?.(status, startDate);
      return status;
    }
  }
};

export const canFileClaim = (coverageStartDate: string) => (
  (dayjs().isAfter(coverageStartDate) || dayjs().isSame(coverageStartDate, 'day'))
);
